import api from "@/lib/api";
import type { PaginatedResponse } from "@/types/common/api-types";

export interface CRUDApiParams {
  page?: number;
  size?: number;
  name?: string;
  active_only?: boolean;
  [key: string]: any;
}

export function createCRUDApi<T, TCreate, TUpdate>(endpoint: string) {
  return {
    getAll: async (params?: CRUDApiParams): Promise<PaginatedResponse<T>> => {
      const response = await api.get<PaginatedResponse<T>>(endpoint, { params });
      return response.data;
    },

    getById: async (id: number): Promise<T> => {
      const response = await api.get<T>(`${endpoint}/${id}`);
      return response.data;
    },

    create: async (data: TCreate): Promise<T> => {
      const response = await api.post<T>(endpoint, data);
      return response.data;
    },

    update: async (id: number, data: TUpdate): Promise<T> => {
      const response = await api.put<T>(`${endpoint}/${id}`, data);
      return response.data;
    },

    delete: async (id: number): Promise<void> => {
      await api.delete(`${endpoint}/${id}`);
    },
  };
}
